"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const recoil_1 = require("recoil");
const storyCreateStates_1 = require("./storyCreateStates");
const components_1 = require("@/common/components");
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isUpdate = window.location.pathname.includes('update');
    const [{ public_status, closed }, setStoryData] = (0, recoil_1.useRecoilState)(storyCreateStates_1.storyDataState);
    return ((0, jsx_runtime_1.jsxs)(OtherSettingsWrapper, { children: [(0, jsx_runtime_1.jsx)("h2", { children: t('기타 설정') }), (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { control: (0, jsx_runtime_1.jsx)(components_1.IOSSwitch, { checked: !public_status, onChange: () => {
                        setStoryData(prev => (Object.assign(Object.assign({}, prev), { public_status: Number(!public_status) })));
                    } }), label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", { children: t('공개 허용') }), (0, jsx_runtime_1.jsx)(CheckedStateText, Object.assign({ checked: !public_status }, { children: !public_status ? ((0, jsx_runtime_1.jsx)("span", { children: t('검색/구독/폰디채널') })) : ((0, jsx_runtime_1.jsx)("span", { children: t('링크만 허용') })) }))] }), labelPlacement: "start" }), isUpdate && ((0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { control: (0, jsx_runtime_1.jsx)(components_1.IOSSwitch, { checked: !closed, onChange: () => {
                        setStoryData(prev => (Object.assign(Object.assign({}, prev), { closed: !closed })));
                    } }), label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", { children: t('마감') }), (0, jsx_runtime_1.jsx)(CheckedStateText, Object.assign({ checked: !closed }, { children: !closed ? (0, jsx_runtime_1.jsx)("span", { children: t('연재 가능') }) : (0, jsx_runtime_1.jsx)("span", { children: t('연재 불가') }) }))] }), labelPlacement: "start" }))] }));
}
exports.default = default_1;
const OtherSettingsWrapper = styled_1.default.div `
  padding: 20px 16px 8px;
  background-color: white;
  h2 {
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 17px;
  }
  h4 {
    margin-right: 4px;
    font-weight: 400;
    font-size: 17px;
  }
  .MuiFormControlLabel-root {
    display: flex;
    justify-content: space-between;
    margin: 0 0 12px;
  }
  .MuiFormControlLabel-label {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;
    margin-right: 10px;
    .other_setting_label_group {
      display: flex;
      align-items: center;
    }
  }
`;
// eslint-disable-next-line prettier/prettier
const CheckedStateText = styled_1.default.span `
  color: ${props => (props.checked ? 'var(--primary-dark)' : 'rgba(0, 0, 0, 0.2)')};
  font-size: 17px;
`;
